import { fetchAuthSession } from 'aws-amplify/auth';

export const getJwt = async () => {
  const user = await fetchAuthSession();
  return user.tokens?.accessToken;
};
